export default __webpack_public_path__ + "static/media/mercy-ult.c672d241.mp3";